module.exports = __webpack_public_path__ + "img/videowiki.eb8b7135.svg";